export default __webpack_public_path__ + "static/media/illustration.8b20b41a.svg";